// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedContentSidebar-cls1___821607b4aedce02530e","cls2":"SuggestedContentSidebar-cls2___a2067802093eb78507c SuggestedContentSidebar-cls1___821607b4aedce02530e"};